import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const TabContainer = styled.div`
  display: flex;
  gap: 16px;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Tab = styled.div`
  cursor: pointer;
  color: ${colors.gray400};
`;
